var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('div',{staticClass:"error-img"},[_c('img',{attrs:{"src":require("../../assets/images/403.png")}})]),_c('span',{staticClass:"error-explain"},[_vm._v("哎呀，权限不足！")])])
}]

export { render, staticRenderFns }